<template>
    <div id="app">
        <NavBar></NavBar>
        <div class="spacer"></div>
        <router-view></router-view>
    </div>
</template>

<script>
import NavBar from './components/NavBar';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
    name: "App",

    components: {
        NavBar
    },

    data: function() {
        return {
        };
    }
};
</script>

<style>
body, html {
    margin: 0;
}

    body {
        background-color: #0F131E !important;
        color: rgba(255, 255, 255, 0.7);;
    }

    .btn-primary {
        background-color: #007bc0;
        border-color: #007bc0;
    }

    .spacer {
        height: 50px;
    }
</style>
